import React, { useState, useEffect, Fragment } from 'react';

import { ShoppingCart, Person, PersonOutline, ShoppingCartOutlined, MoreVert } from '@material-ui/icons';

import { get } from 'js-cookie';
import { bool, object, func, string, oneOfType, number } from 'prop-types';

import HeaderCartMenu from '../../../../components/HeaderCartMenu';
import { HeaderUserMenu, HeaderMoreMenu } from '../../../../components/HeaderMobileMenus';

import { ButtonIcon, UserInfo, BadgeStyled, Text, SignUp } from './styles';

function HeaderUser({
  cart,
  visibility,
  cartFreight,
  cartFreightRequest,
  isLoading,
  error,
  customerName,
  customerId,
  inputId,
  domain,
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorElCart, setAnchorElCart] = useState(null);
  const [anchorMore, setAnchorMore] = useState(null);
  const isLogged = Boolean(customerId);

  useEffect(() => {
    return () => {
      setAnchorEl(null);
      setAnchorElCart(null);
      setAnchorMore(null);
    };
  }, [visibility]);

  const handleClick = ({ currentTarget }) => {
    setAnchorEl(currentTarget);
  };

  const handleMore = ({ currentTarget }) => {
    setAnchorMore(currentTarget);
  };

  const handleClickCart = ({ currentTarget }) => {
    setAnchorElCart(currentTarget);
  };

  return (
    <Fragment>
      <HeaderCartMenu
        cart={cart}
        anchorEl={anchorElCart}
        setAnchorEl={setAnchorElCart}
        cartFreight={cartFreight}
        isLoading={isLoading}
        cartFreightRequest={cartFreightRequest}
        error={error}
        inputId={inputId}
        domain={domain}
      />
      <HeaderUserMenu anchorEl={anchorEl} setAnchorEl={setAnchorEl} isLogged={isLogged} domain={domain} />
      <HeaderMoreMenu anchorEl={anchorMore} setAnchorEl={setAnchorMore} />

      <ButtonIcon onClick={handleClick} title="Minha Conta" aria-label="Minha Conta">
        {isLogged && <Person />}
        {!isLogged && <PersonOutline />}
      </ButtonIcon>
      <UserInfo>
        <Text bold="true">Bem-vindo</Text>
        {isLogged && <Text>{customerName || get('customer.nickName') || 'Cliente Ecommerce'}</Text>}
        {!isLogged && (
          <SignUp>
            <a href="/cliente/login" title="Entre" aria-label="Entre">
              Entre
            </a>
            {' ou '}
            <a href="/cliente/cadastro" title="Cadastre-se" aria-label="Cadastre-se">
              Cadastre-se
            </a>
          </SignUp>
        )}
      </UserInfo>

      <ButtonIcon title="Meu Carrinho" aria-label="Minha Conta" onClick={handleClickCart}>
        <BadgeStyled badgeContent={cart.getIn(['products', 'quantity'])} color="secondary" overlap="rectangular">
          <>
            {cart.getIn(['products', 'quantity']) > 0 && <ShoppingCart />}
            {(cart.getIn(['products', 'quantity']) <= 0 || !cart.getIn(['products', 'quantity'])) && (
              <ShoppingCartOutlined />
            )}
          </>
        </BadgeStyled>
      </ButtonIcon>
      <ButtonIcon mobile="true" title="Ver mais opções" aria-label="Ver mais opções" onClick={handleMore}>
        <MoreVert />
      </ButtonIcon>
    </Fragment>
  );
}

HeaderUser.propTypes = {
  cart: object,
  visibility: bool,
  cartFreight: object,
  cartFreightRequest: func,
  isLoading: bool,
  error: object,
  customerName: string,
  customerId: oneOfType([string, number]),
  inputId: string,
  domain: string,
};

export default HeaderUser;
